module.exports = __webpack_public_path__ + "static/jc04657-preparation-step-02-161808d17000a14a2abccfc579d896a4.png";